import { fabric } from 'fabric';

const handlers = {
  default: (Cls, data) => new Cls(data),
  Text: (Cls, data) => new Cls(data.text, data),
  Image: (Cls, data, orig) => new fabric.Image(orig._element, data),
};

export const cloneFabricObject = (original, overrides = {}) => {
  const data = { 
    ...original.toObject(), 
    ...overrides, 
    id: original.id,
    element_id: original.element_id,
  };
  const type = original.type.charAt(0).toUpperCase() + original.type.slice(1);
  const Cls = fabric[type] || fabric.Object;

  const handler = handlers[type.includes("Text") ? "Text" : type] || handlers.default;
  return handler(Cls, data, original);
}
